
import {
  ParagraphBlock,
  ParagraphContent,
  ParagraphSlider,
  ParagraphCards,
  ParagraphHero,
  ParagraphCardsCard,
  ParagraphNews,
  ParagraphProjects,
  ParagraphStoriesSelection,
  ParagraphFAQ,
  ParagraphOldFAQ,
  ParagraphVideo,
  ParagraphVideoHeader,
  ParagraphImages,
  ParagraphQuote,
  ParagraphAuthor,
  ParagraphPodcast,
  CTAWrapper,
  CTAContent,
  WebformParagraph,
  ContactPersonParagraph,
  MemberStoriesOverviewParagraph,
  ParagraphContentSlider,
  ParagraphDownloads,
  ParagraphSelectedThemes,
  ParagraphQuestionsOverview,
  ParagraphQuestionsOverviewItem,
  ParagraphVideoSeries,
  ParagraphText,
  ParagraphTextImageGrid,
  ParagraphTextMedia,
  ParagraphContentOverview,
  ParagraphHighlightedSelection,
  ParagraphNLdoetSearch,
  ParagraphBlockReference,
  ParagraphAVOPreviousYears,
  ParagraphAvOWinners,
} from '../implementations';

const mappers = {
  block_reference: ParagraphBlockReference,
  content: ParagraphContent,
  slider: ParagraphSlider,
  cards: ParagraphCards,
  card: ParagraphCardsCard,
  news: ParagraphNews,
  projects: ParagraphProjects,
  stories_compact: ParagraphStoriesSelection,
  content_overview: ParagraphContentOverview,
  highlighted_selection: ParagraphHighlightedSelection,
  cta_wrapper: CTAWrapper,
  hero: ParagraphHero,
  cta: CTAContent,
  faq: ParagraphFAQ,
  faq_selection: ParagraphOldFAQ,
  block: ParagraphBlock,
  video: ParagraphVideo,
  video_header: ParagraphVideoHeader,
  podcast: ParagraphPodcast,
  webform_wrapper: WebformParagraph,
  contact_person: ContactPersonParagraph,
  member_stories: MemberStoriesOverviewParagraph,
  images: ParagraphImages,
  quote: ParagraphQuote,
  author: ParagraphAuthor,
  content_slider: ParagraphContentSlider,
  downloads: ParagraphDownloads,
  selected_themes: ParagraphSelectedThemes,
  questions_overview: ParagraphQuestionsOverview,
  questions_overview_item: ParagraphQuestionsOverviewItem,
  video_series: ParagraphVideoSeries,
  text: ParagraphText,
  text_media: ParagraphTextMedia,
  text_image_grid: ParagraphTextImageGrid,
  nldoet_search: ParagraphNLdoetSearch,
  avo_previous_years: ParagraphAVOPreviousYears,
  avo_winners: ParagraphAvOWinners,
};

export default mappers;
